import styled from "styled-components";

export const SInformationModalButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 240px;
`;
